import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Page from '../../index'
import PageSectionHeader from '../../../features/components/PageSectionHeader'
import ReportMenu from './ReportMenu'
import ReportContent from './ReportContent'
import SroiReportPayloadEdit from './forms/SroiReportPayloadEdit'
import ReportFilters from './ReportFilters'
import { SroiFiltersProvider } from './SroiFiltersContext'
import { PdfExportProvider } from './PdfExportContext'
import SroiInfoPanels from './ReportContent/SroiInfoPanels'
import SectionHeaderRightPanel from './SectionHeaderRightPanel'
import TotalsSummaryPanels from './TotalsSummaryPanels'
import HiddenExportCopy from './components/HiddenExportCopy'

import {
  clearGetSocialReturnOnInvestmentReport,
  getSocialReturnOnInvestmentReport
} from '../../../modules/actions/socialReturnOnInvestment'
import { pdfGenerationSelector } from '../../../modules/selectors/app'

import { sectionIds } from './constants'

const SocialReturnOnInvestment = () => {
  const dispatch = useDispatch()

  const [selectedReport, setSelectedReport] = useState(null)
  const [selectedYear, setSelectedYear] = useState(null)

  const isPdfGenerating = useSelector(pdfGenerationSelector)
  const selectedReportId = useMemo(() => selectedReport?.id, [selectedReport])

  const fetchSroiReportHandler = useCallback(() => {
    if (selectedReportId) {
      dispatch(getSocialReturnOnInvestmentReport({ id: selectedReportId }))
    }
  }, [dispatch, selectedReportId])

  useEffect(() => {
    fetchSroiReportHandler()
  }, [fetchSroiReportHandler])

  useEffect(() => {
    return () => {
      dispatch(clearGetSocialReturnOnInvestmentReport())
    }
  }, [dispatch])

  return (
    <Page helmetTitle="sroi">
      <PdfExportProvider>
        <SroiReportPayloadEdit fetchSroiReportHandler={fetchSroiReportHandler} />
        <PageSectionHeader
          title="Social Impact Evaluation"
          RightPanel={<SectionHeaderRightPanel selectedYear={selectedYear} setSelectedYear={setSelectedYear} />}
        />
        <ReportMenu selectedYear={selectedYear} selectedReport={selectedReport} setSelectedReport={setSelectedReport} />

        {selectedReport && (
          <SroiFiltersProvider
            // reset filters when report changes
            key={selectedReportId}
          >
            <div id={sectionIds.sroiInfoPanels}>
              <SroiInfoPanels />
            </div>
            <div id={sectionIds.sroiFilters}>
              <ReportFilters />
            </div>
            <div id={sectionIds.totalsSummaryPanels}>
              <TotalsSummaryPanels />
            </div>
            <ReportContent />

            {isPdfGenerating && selectedReport && (
              <HiddenExportCopy id={`${sectionIds.sroiInfoPanels}-export`}>
                <SroiInfoPanels isExportCopy />
              </HiddenExportCopy>
            )}
          </SroiFiltersProvider>
        )}
      </PdfExportProvider>
    </Page>
  )
}

export default SocialReturnOnInvestment
